import { Grid } from '@material-ui/core';
import { Text } from 'library';
import React from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { IHiredProvider } from '../models';
import { isLoggedIn } from 'api/UserApi';

export default function FamilyHiredCaption({ hiredProvider }: { hiredProvider: IHiredProvider }) {
    function getHiredCaption() {
        if (isLoggedIn()) {
            return (
                <Text variant="deprecatedCaption">
                    {hiredProvider.hired_family} hired {hiredProvider.provider.user.first_name}{' '}
                    {hiredProvider.provider.user.last_name[0]}.
                </Text>
            );
        }
        return (
            <Text variant="deprecatedCaption">
                <Text
                    variant="deprecatedCaption"
                    textStyle={{ color: 'transparent', textShadow: '0 0 5px rgba(0,0,0,0.5)', display: 'inline' }}
                >
                    {hiredProvider.hired_family}
                </Text>{' '}
                hired {hiredProvider.provider.user.first_name} {hiredProvider.provider.user.last_name[0]}.
            </Text>
        );
    }
    return (
        <Grid container item direction="row" alignItems="center">
            <CheckCircleIcon style={{ fontSize: 14, color: 'green', marginRight: 5 }} />
            {getHiredCaption()}
        </Grid>
    );
}
